const tourcategory = {
    getlist: 'tourcategory/getlist',
    add: 'tourcategory/add',
    update: 'tourcategory/update',
    remove: 'tourcategory/remove',
    get: 'tourcategory/get',
    getall: 'tourcategory/getall',
    clearcache: 'tourcategory/clear-cache',
}
export default tourcategory
